<script>
import 'floating-vue/dist/style.css'

import Vue from 'vue'
import { Tooltip } from 'floating-vue'

Vue.component('VTooltip', Tooltip)

export default {
    props: ["data", "cartSummary"],
    data() {
        return {
            showAllVariants: false,
            isOverflowing: false,
            hiddenNames: [],
            showVariantChipsOnClient: false,
        };
    },
    mounted() {
        this.checkOverflow();
        this.showVariantChipsOnClient = true;
    },
    watch: {
        'selectedVariants': {
            handler() {
                this.$nextTick(() => {
                    this.checkOverflow();
                    this.checkEllipsis()
                });
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        checkOverflow() {
            const el = this.$refs.variantContainer;
            if (el) {
                const lineHeight = 28; // Approximate height per row
                this.isOverflowing = el.scrollHeight > lineHeight * 2 + 5; // allow slight tolerance
            }
        },
        toggleShow() {
            this.showAllVariants = !this.showAllVariants;
        },
        checkEllipsis() {
            this.hiddenNames = this.selectedVariants.map((_, i) => {
                const el = this.$refs[`name-${i}`];
                if (Array.isArray(el) && el[0]) {
                    return el[0].scrollWidth > el[0].clientWidth;
                }
                return el && el.scrollWidth > el.clientWidth;
            });
        },
        isNameHidden(i) {
            return this.hiddenNames[i];
        },
    },
    computed: {
        selectedVariants() {
            return (this.data.multiplyVariations && this.data.cartOrder && this.cartSummary.length > 0)
                ? this.cartSummary
                : this.data.variablePrices
        },
        showQuantity() {
            if (this.data.cartOrder) return this.data.addQuantity
            return true
        }
    },
};
</script>

<template>
    <div v-if="showVariantChipsOnClient">
        <div class="select-variant-container" :class="{ 'collapsed': !showAllVariants && isOverflowing }"
            ref="variantContainer">
            <template v-for="(variant, i) in selectedVariants">
                <VTooltip v-if="variant.qty > 0 && (data.multiplyVariations || (!data.multiplyVariations && data.addQuantity))" :key="'variant_chip_' + variant.name" :disabled="!isNameHidden(i)" :triggers="['click', 'focus']" :delay="0" placement="bottom" style="flex: 1 1 30%; max-width: fit-content;">
                    <div role="button" tabindex="0" class="select-variant-chip" :id="variant.name">
                        <img src="@/assets/icons/check-green.png" alt="check icon" />
                        <div :ref="`name-${i}`" class="variant-name">{{ variant.name }}</div>
                        <span v-if="variant.qty > 0 && showQuantity" class="flex-shrink-0">: {{`${variant.qty}x` }}</span>
                    </div>
                    <template #popper>
                        <span style="font-size: 14px; font-weight: 500;">{{ variant.name }}</span>
                    </template>
                </VTooltip>

                <!-- handle single variant chips -->
                 <div :key="'variant_chip_' + variant.name" v-if="variant.qty > 0 && !data.multiplyVariations && !data.addQuantity" class="select-variant-container">
                    <VTooltip v-for="(singleName, j) in (variant.name || '').split('/')" :key="'variant_chip_' + singleName" :disabled="!isNameHidden(j)" :triggers="['click', 'focus']" :delay="0" placement="bottom" style="flex: 1 1 30%; max-width: fit-content;">
                        <div role="button" tabindex="0" class="select-variant-chip" :id="singleName">
                            <img src="@/assets/icons/check-green.png" alt="check icon" />
                            <div :ref="`name-${j}`" class="variant-name">{{ singleName }}</div>
                        </div>
                        <template #popper>
                            <span style="font-size: 14px; font-weight: 500;">{{ singleName }}</span>
                        </template>
                    </VTooltip>
                </div>
            </template>
        </div>

        <button v-if="isOverflowing" @click="toggleShow" class="toggle-button font-bold w-100" style="color: #2E47BA">
            {{ showAllVariants ? 'Sembunyikan' : 'Tampilkan Semua' }}
        </button>
    </div>
</template>

<style lang="scss" scoped>
.select-variant-container {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    transition: max-height 0.3s ease;
    overflow: hidden;

    &.collapsed {
        max-height: 56px; // roughly 2 rows of ~35px + gap
    }
}

.select-variant-chip {
    display: flex;
    align-items: center;
    gap: 2px;
    height: 24px;
    width: 100%;
    max-width: 240px;
    color: #14AD4D;
    border: 1px solid #14AD4D;
    background-color: #EBFBF1;
    border-radius: 4px;
    padding: 4px 8px;
    font-size: 14px;
    font-weight: 500;

    & > * {
        pointer-events: none;
    }

    .flex-shrink-0 {
        flex-shrink: 0;
    }

    .variant-name {
        width: 100%;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }

    img {
        width: 18px;
        height: 18px;
        padding: 2px;
    }
}

.toggle-button {
    margin-top: 8px;
    background: none;
    border: none;
    color: #007BFF;
    cursor: pointer;
    font-size: 14px;
    padding: 0;
}
</style>

<style lang="scss">
.v-popper {
    &[disabled] {
        opacity: 1 !important;
    }

    &__inner {
        box-shadow: 0px 0px 1px -1px #E0E9F4, 0px 0px 20px 15px #0a090b0b;
        padding: 12px;
        border-radius: 8px;
        color: #203551 !important;
        background-color: #FFF !important;
    }

    &__arrow-outer {
        border-color: white !important;
    }
}
</style>